import React from "react";
import Stats from "./stats";
import Icon from "../../_default/Icon"
import "./Profile.scss";
import FeatherIcon from "feather-icons-react";
import logo from '../../../assets/images/logo.svg';
export default function Profile({ user, clientCount, workoutCount }) {
    return(
        <div className="c-header">
            <div className="c-header-container">
                <div className="c-profile-data">
                    <div className="c-profile-list-image" style={{ backgroundImage: `url('${user.image}')` }}></div>
                    <div className="c-profile-data-wrapper">
                        <div className="c-profile-data-fields">
                            <p>{user?.first_name} {user.last_name}</p>
                        </div>
                        <div className="c-profile-stats">
                            <Stats icon="users" name="Clients" stroke='#CCC' size={12} count={clientCount}></Stats>
                            {/* <Stats icon="exercise" stroke='#CCC' name="Custom exercises" size={12} count={workoutCount}></Stats>  */}
                        </div>
                    </div>
                </div>
                <div className="c-header-add">
                </div>
                <div className="c-header-logo" style={{ paddingRight: 60 }}>
                    <img src={logo} alt="Logo" />
                </div>
            </div>
        </div>
    );
}


